import React from "react";
import { Flash } from "../../../shared/lib/types";
import Footer from "../../shared/components/app/Footer";
import BackgroundBuildingImage from "../../shared/components/app/BackgroundBuildingImage";
import Background from "../../shared/components/ui/Background";
import { Box } from "../../shared/components/ui/chakra";
import Application from "../../shared/components/layouts/Application";
import { SharedApprovedCurrentUser } from "../../shared/lib/types";
import BusinessEntityShowContent from "../shared/components/BusinessEntityShowContent";
import { BusinessEntity } from "./lib/types";
import SpTalkMessageButton from "./components/SpTalkMessageButton";
import BusinessMatchingHeader from "../shared/components/BusinessMatchingHeader";
import BusinessEntityShowPreviewLayout from "../shared/components/BusinessEntityShowPreviewLayout";

const BusinessEntitiesShow = ({
  flash,
  businessEntity,
  currentUser,
  isShowByAdmin,
}: {
  flash: Flash;
  businessEntity: BusinessEntity;
  currentUser: SharedApprovedCurrentUser;
  isShowByAdmin: boolean;
}) => {
  if (isShowByAdmin) {
    return (
      <BusinessEntityShowPreviewLayout>
        <BusinessEntityShowContent businessEntity={businessEntity} currentUser={currentUser} preview />
      </BusinessEntityShowPreviewLayout>
    );
  } else {
    return (
      <Application flash={flash} currentUser={currentUser}>
        <BusinessMatchingHeader currentUser={currentUser} />
        <Box>
          <Background color="brand.50">
            <BusinessEntityShowContent businessEntity={businessEntity} currentUser={currentUser} />
          </Background>
          <BackgroundBuildingImage
            // positionをabsoluteにすると、width、transformも指定しないと横に空白が生まれる
            position="absolute"
            width="full"
            transform=""
            // 191px = SP時のfooter
            // 83px = SP時の追従お問い合わせリンク
            // 99px = PC時のfooter
            bottom={{ base: "calc(191px + 83px)", sm: "99px" }}
          />
          <SpTalkMessageButton />
          <Box position="relative">
            <Footer />
          </Box>
        </Box>
      </Application>
    );
  }
};
export default BusinessEntitiesShow;
